// 0 is an explicit opt-out, not a missing value. Existing websites keep the
// four-star default; null, blank or invalid input must never disable guidance.
export const normalizeCrmReviewPageMinRating = (value) => {
  if (value === 0 || (typeof value === 'string' && value.trim() === '0')) return 0
  const numeric = Number(value)
  return numeric === 2 || numeric === 3 || numeric === 5 ? numeric : 4
}

export const shouldGuideCrmPlatformReview = (rating, minRating) => {
  const threshold = normalizeCrmReviewPageMinRating(minRating)
  const numericRating = Number(rating)
  return threshold !== 0 && Number.isFinite(numericRating) &&
    numericRating >= 1 && numericRating <= 5 && numericRating >= threshold
}
